import React from 'react'
import cx from 'classnames'

import { COUNTRY, IS_ID, IS_PH } from 'constants/config'
import { Text } from 'components/Typography'

import appLogoWhite from 'assets/logos/appLogoWhite'

import heroPh from './hero_ph.jpg'
import heroId1 from './hero_id_1.jpg'
import heroId2 from './hero_id_2.jpg'

import styles from './Testimonials.module.scss'

const getTestimonial = (variant?: number) => {
  switch (COUNTRY) {
    case 'PH':
      return {
        message:
          '“Super nakatulong at convenient ng Bukas. Ang bilis lang mag-apply at diretso na ang bayad sa school!”',
        details:
          'Minerva, Guardian of Conrad from Lyceum of the Philippines University',
        photo: heroPh,
        logo: '',
      }
    case 'ID':
      if (variant === 1) {
        return {
          message:
            '"Tentunya saya akan merekomendasikan teman-teman di President University untuk menggunakan Danacita bila dibandingkan dengan pembiayaan lainnya. Danacita prosesnya cepat, syaratnya mudah, dan customer success team nya juga sangat ramah akan menuntun kamu dari awal hingga akhir."',
          details: 'Faquita Zahra Ramadanti',
          photo: heroId1,
        }
      }
      return {
        message:
          '"Danacita menjadi solusi saya dalam membayar pendidikan di kondisi sekarang. Saya berharap Danacita bukan hanya untuk di jenjang pendidikan tinggi tetapi bisa di sekolah dasar atau sekolah menengah. Saya sangat merekomendasikan Danacita. Jika saya tidak menggunakan Danacita, mungkin saya akan lanjut kuliah dengan kondisi keuangan yang sangat minim dan bisa berdampak tidak lanjut kuliah."',
        details: 'Rizka Sari',
        photo: heroId2,
      }
    default:
      return {
        message:
          '“Super nakatulong at convenient ng Bukas. Ang bilis lang mag-apply at diretso na ang bayad sa school!”',
        details:
          'Minerva, Guardian of Conrad from Lyceum of the Philippines University',
        photo: heroPh,
        logo: '',
      }
  }
}

type Props = {
  className?: string
  compact?: boolean
  variant?: number
}

const Testimonials = (props: Props) => {
  const { className, compact, variant } = props
  const { details, logo, message, photo } = getTestimonial(variant)
  return (
    <section
      className={cx(styles.testimonials, compact && styles.compact, className)}
    >
      <div
        className={IS_PH ? styles.bgPh : styles.bgId}
        style={photo ? { backgroundImage: `url(${photo})` } : undefined}
      />

      <div className={IS_PH ? styles.contentPh : styles.contentId}>
        {!compact && (
          <img className={styles.appLogo} src={appLogoWhite} alt="App logo" />
        )}

        {IS_ID && (
          <div className={styles.testimonial}>
            {logo && !compact && (
              <img
                className={styles.partnerLogo}
                src={logo}
                alt="Partner logo"
              />
            )}
            <Text
              block
              size={compact ? undefined : 'xl'}
              type="white"
              className={styles.message}
            >
              {message}
            </Text>
            <Text block strong size={compact ? 'xs' : undefined} type="white">
              {details}
            </Text>
          </div>
        )}
      </div>
    </section>
  )
}

export default Testimonials
